export const regions = {
  'auckland' : 'Auckland',
'bay-of-plenty' : 'Bay of Plenty',
'canterbury' : 'Canterbury',
'gisborne' : 'Gisborne',
'hawkes-bay' : 'Hawkes Bay',
'manawatu-whanganui' : 'Manawatu-Whanganui',
'marlborough' : 'Marlborough',
'nelson' : 'Nelson',
'northland' : 'Northland',
'otago' : 'Otago',
'southland' : 'Southland',
'taranaki' : 'Taranaki',
'tasman' : 'Tasman',
'waikato' : 'Waikato',
'wellington' : 'Wellington',
'west-coast' : 'West Coast',
};